import { render } from "./SearchQuestionByTextContent.vue?vue&type=template&id=585a4bd0&scoped=true"
import script from "./SearchQuestionByTextContent.vue?vue&type=script&lang=js"
export * from "./SearchQuestionByTextContent.vue?vue&type=script&lang=js"

import "./SearchQuestionByTextContent.vue?vue&type=style&index=0&id=585a4bd0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585a4bd0"]])

export default __exports__